// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * The small pieces every Scenario Catalog surface shares: the colour swatch,
 * and the node lists of the details view.
 *
 * A scenario's colour is data, not a theme token: each element that wears it
 * sets \`--scenario-color\` on itself and these rules read it.
 */

.eKdcTcldVqrbPWmzisYn {
  display: inline-block;
  flex-shrink: 0;
  width: 10px;
  height: 10px;
  border-radius: 3px;
  background: var(--scenario-color, var(--curio-kind-dataflow-fg));
  vertical-align: baseline;
}

/* A title with its swatch in front. */
.mmT1fc4Pr_ZwC98fN8kF {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

/* The project graph with the scenario marked, in the details view. */
.p9oqcLQyEHBloZmUxd0j {
  height: 180px;
  margin: 0 0 20px;
  border: 1px solid var(--curio-border);
  border-radius: 8px;
  overflow: hidden;
}

.nyBQjD4Qgcymr3dVUP6A {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.Q_lRIZVL91j3xmzZm9Jb {
  padding: 8px 10px;
  border: 1px solid var(--curio-border);
  border-radius: 6px;
  font-size: 13px;
  color: var(--curio-text-primary);
}

.LkrDK_EpO9_NwQqQMW4g {
  font-weight: 600;
  overflow-wrap: anywhere;
}

.lGCWhxKGsNBx18onlUki {
  margin-left: 8px;
  font-family: var(--curio-font-mono);
  font-size: 12px;
  color: var(--curio-text-secondary);
}

.zwbdNM7aE6d15px4PG2d {
  margin: 4px 0 0;
  padding-left: 18px;
  font-size: 12px;
  line-height: 1.5;
  color: var(--curio-text-secondary);
}

.VC2dSXZq7BTUlpRCtxPu {
  margin: 4px 0 0;
  font-size: 12px;
  color: var(--curio-text-meta);
}

.dYhYnDID35L2odUAmnpa {
  margin: 0;
  font-size: 13px;
  color: var(--curio-text-meta);
}

/* The name, color and description of a scenario of the open dataflow, edited
   in its details: a label column and a field column. */
.E6T90hzUj4x_3NIBwDPB {
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  gap: 8px 12px;
  align-items: center;
  margin: 0 0 20px;
}

.J6Xsw8wpcvfDlphl1NkV {
  font-size: 12px;
  font-weight: 600;
  color: var(--curio-text-secondary);
}

.Co8RSrEVo3LpoxwF3kVM {
  min-width: 0;
  padding: 6px 8px;
  border: 1px solid var(--curio-border-strong);
  border-radius: 6px;
  background: var(--curio-card-bg);
  color: var(--curio-text-primary);
  font-family: inherit;
  font-size: 13px;
  resize: vertical;
}

.ZclkeCbNcbVc8_uOnToB {
  width: 44px;
  height: 28px;
  padding: 2px;
  border: 1px solid var(--curio-border-strong);
  border-radius: 6px;
  background: var(--curio-card-bg);
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/scenarios/catalog/scenarioFacts.module.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;EACE,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gEAAgE;EAChE,wBAAwB;AAC1B;;AAEA,sCAAsC;AACtC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,6BAA6B;AAC/B;;AAEA;uDACuD;AACvD;EACE,aAAa;EACb,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,4CAA4C;EAC5C,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB","sourcesContent":["/*\n * The small pieces every Scenario Catalog surface shares: the colour swatch,\n * and the node lists of the details view.\n *\n * A scenario's colour is data, not a theme token: each element that wears it\n * sets `--scenario-color` on itself and these rules read it.\n */\n\n.swatch {\n  display: inline-block;\n  flex-shrink: 0;\n  width: 10px;\n  height: 10px;\n  border-radius: 3px;\n  background: var(--scenario-color, var(--curio-kind-dataflow-fg));\n  vertical-align: baseline;\n}\n\n/* A title with its swatch in front. */\n.named {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n/* The project graph with the scenario marked, in the details view. */\n.detailThumb {\n  height: 180px;\n  margin: 0 0 20px;\n  border: 1px solid var(--curio-border);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.nodeList {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.nodeItem {\n  padding: 8px 10px;\n  border: 1px solid var(--curio-border);\n  border-radius: 6px;\n  font-size: 13px;\n  color: var(--curio-text-primary);\n}\n\n.nodeLabel {\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n\n.nodeParameter {\n  margin-left: 8px;\n  font-family: var(--curio-font-mono);\n  font-size: 12px;\n  color: var(--curio-text-secondary);\n}\n\n.resultList {\n  margin: 4px 0 0;\n  padding-left: 18px;\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--curio-text-secondary);\n}\n\n.noOutput {\n  margin: 4px 0 0;\n  font-size: 12px;\n  color: var(--curio-text-meta);\n}\n\n.none {\n  margin: 0;\n  font-size: 13px;\n  color: var(--curio-text-meta);\n}\n\n/* The name, color and description of a scenario of the open dataflow, edited\n   in its details: a label column and a field column. */\n.fields {\n  display: grid;\n  grid-template-columns: max-content minmax(0, 1fr);\n  gap: 8px 12px;\n  align-items: center;\n  margin: 0 0 20px;\n}\n\n.fieldLabel {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--curio-text-secondary);\n}\n\n.fieldInput {\n  min-width: 0;\n  padding: 6px 8px;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: 6px;\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary);\n  font-family: inherit;\n  font-size: 13px;\n  resize: vertical;\n}\n\n.fieldColor {\n  width: 44px;\n  height: 28px;\n  padding: 2px;\n  border: 1px solid var(--curio-border-strong);\n  border-radius: 6px;\n  background: var(--curio-card-bg);\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"swatch": `eKdcTcldVqrbPWmzisYn`,
	"named": `mmT1fc4Pr_ZwC98fN8kF`,
	"detailThumb": `p9oqcLQyEHBloZmUxd0j`,
	"nodeList": `nyBQjD4Qgcymr3dVUP6A`,
	"nodeItem": `Q_lRIZVL91j3xmzZm9Jb`,
	"nodeLabel": `LkrDK_EpO9_NwQqQMW4g`,
	"nodeParameter": `lGCWhxKGsNBx18onlUki`,
	"resultList": `zwbdNM7aE6d15px4PG2d`,
	"noOutput": `VC2dSXZq7BTUlpRCtxPu`,
	"none": `dYhYnDID35L2odUAmnpa`,
	"fields": `E6T90hzUj4x_3NIBwDPB`,
	"fieldLabel": `J6Xsw8wpcvfDlphl1NkV`,
	"fieldInput": `Co8RSrEVo3LpoxwF3kVM`,
	"fieldColor": `ZclkeCbNcbVc8_uOnToB`
};
export default ___CSS_LOADER_EXPORT___;
